import { Sizes, States, Types } from './constants';
import Loading from '@doordash/component-loading';
export var colorForType = function colorForType(isToggleable, isToggled, buttonType, isDisabled) {
  switch (buttonType) {
    case Types.FlatPrimary:
      return isDisabled ? 'ButtonFlatPrimaryForegroundDisabled' : 'ButtonFlatPrimaryForeground';

    case Types.FlatSecondary:
      return 'ButtonFlatSecondaryForeground';

    case Types.Plain:
      return isDisabled ? 'ButtonPlainForegroundDisabled' : 'ButtonPlainForeground';

    case Types.Secondary:
    case Types.SecondaryPill:
      {
        if (isToggleable) {
          // eslint-disable-next-line no-nested-ternary
          return isToggled ? isDisabled ? 'ButtonSecondaryToggleForegroundDisabled' : 'ButtonSecondaryToggleForeground' : isDisabled ? 'ButtonSecondaryToggleForegroundOffDisabled' : 'ButtonSecondaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonSecondaryForegroundDisabled' : 'ButtonSecondaryForeground';
      }

    case Types.Tertiary:
    case Types.TertiaryPill:
      {
        if (isToggleable) {
          // eslint-disable-next-line no-nested-ternary
          return isToggled ? isDisabled ? 'ButtonTertiaryToggleForegroundDisabled' : 'ButtonTertiaryToggleForeground' : isDisabled ? 'ButtonTertiaryToggleForegroundOffDisabled' : 'ButtonTertiaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonTertiaryForegroundDisabled' : 'ButtonTertiaryForeground';
      }

    case Types.Primary:
    case Types.PrimaryPill:
    case Types.Full:
    default:
      {
        if (isToggleable) {
          // eslint-disable-next-line no-nested-ternary
          return isToggled ? isDisabled ? 'ButtonPrimaryToggleForegroundDisabled' : 'ButtonPrimaryToggleForeground' : isDisabled ? 'ButtonPrimaryToggleForegroundOffDisabled' : 'ButtonPrimaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonPrimaryForegroundDisabled' : 'ButtonPrimaryForeground';
      }
  }
};
export var loadingSizeForButton = function loadingSizeForButton(buttonSize) {
  switch (buttonSize) {
    case Sizes.Small:
      return Loading.Sizes.Small;

    case Sizes.Large:
    case Sizes.Xlarge:
      return Loading.Sizes.Large;

    case Sizes.Medium:
    default:
      return Loading.Sizes.Medium;
  }
};
export var loadingStateForButton = function loadingStateForButton(buttonState) {
  switch (buttonState) {
    case States.Error:
      return Loading.States.Error;

    case States.Success:
      return Loading.States.Success;

    case States.Loading:
    default:
      return Loading.States.Loading;
  }
};